define('modules/shell/widgets/datepicker/i18n/it',{
    "datepicker":{
        "clear":"Chiaro"
    }
});

